<template>
  <main class="admin">
    <adminDashboard v-show="path=='dashboard'" />
    <users v-show="path=='users'" />
    <outposts v-show="path=='outposts'" />
    <servants v-show="path=='servants'" />
    <accommodationOrders v-show="path=='accommodationOrders'" />
    <accommodation v-show="path=='accommodation'" />
    <pays v-show="path=='pays'" />
    <priceModifiers v-show="path=='modifiers'" />
    <buses v-show="path=='buses'" />
    <waves v-show="path=='waves'" />
    <activities v-show="path=='activities'" />
    <tournament v-show="path=='tournament'" />
    <fields v-show="path=='fields'" />
    <ages v-show="path=='ages'" />
    <config v-show="path=='config'" />
  </main>
</template>

<script>
import { mapState } from "vuex";
import adminDashboard from "../pages/admin/dashboard";
import users from "../pages/admin/users";
import outposts from "../pages/admin/outposts";
import servants from "../pages/admin/servants";
import accommodationOrders from "../pages/admin/accommodationOrders.vue";
import accommodation from "../pages/admin/accommodation.vue";
import pays from "../pages/admin/pays";
import priceModifiers from "../pages/admin/price_modifiers";
import buses from "../pages/admin/buses";
import waves from "../pages/admin/waves";
import activities from "../pages/admin/activities";
import tournament from "../pages/admin/tournament";
import fields from "../pages/admin/fields";
import ages from "../pages/admin/ages";
import config from "../pages/admin/config";

export default {
  name: "admin",
  components: {
    adminDashboard,
    users,
    outposts,
    servants,
    accommodationOrders,
    accommodation,
    pays,
    priceModifiers,
    buses,
    waves,
    activities,
    tournament,
    fields,
    ages,
    config
  },
  computed: {
    ...mapState(["path"])
  }
};
</script>